import React, {useState} from "react"
import Widget from "../../components/widget";
import Datatable from "../../components/datatable";
import {EnigooLoader} from "../../components/My/EnigooLoader";
import moment from "moment/moment";
import {Button} from "../../components/My/Button";
import Modal from "../../components/My/Modal";
import ReactJson from "react-json-view";

const TableData = ({data, setItem, loading}) => {


    let [visible, setVisible] = useState(false);

    if(loading) return <EnigooLoader/>
    if (!data) return null

    let columns = [
        {Header: 'ID', accessor: "id"},
        {Header: 'Datum vytvoření', accessor: "createdAt",
            Cell: ({cell: {value}}) => <div>{value && moment(value).format("DD.MM.YYYY HH:mm:ss")}</div>},
        {Header: 'Datum parkování', accessor: "parkingDate",
            Cell: ({cell: {value}}) => <div>{value && moment(value).format("DD.MM.YYYY HH:mm:ss")}</div>},
        {Header: 'Areál', accessor: "parkingArealName"},
        {Header: 'ID objednávky', accessor: "orderId"},
        {Header: 'ID vstupenky', accessor: "ticketId"},
        {
            Header: 'Možnosti', accessor: d => (
                <Button text={"Zobrazit data"} onClick={() => setVisible(d.data)}/>
            )
        }

    ];

    const getBody = () =>{
        return(
            <ReactJson src={visible} />
        )
    }


    return (
        <Widget>
            <Datatable data={data} columns={columns}/>

            <Modal body={getBody()} title={"Data"} visible={!!visible}
                   close={() => setVisible(null)}
                   footer={<>
                       <Button outline={true} text={"Zavřít"} onClick={() => setVisible(null)}/>
                   </>
                   }
            />
        </Widget>
    )
}

export default TableData
